import { ITree } from "./ITree"




export interface ITreeCostParams {
    iml: number
    isFolia: number
    isPapier: number
    exact: number
    exactMetry: number
    kolory: number
    koloryZ: number
    cs: number
    hs: number
    lakier: number
    lakier_miejsc: number
    laminat: number
    bielCyfra: number
    kolorCyfra: number
    bielInkjet: number
    kolorInkjet: number
    silverCyfra: number
    sitoProcent: number
    sitoPuchnProcent: number
    silverCyfraProcent: number
    "sito": number
    "sito puchn": number
    sitoPuchn: number
    sitoPuchnZ: number
    pantone: number
    cmyk: number

    sitoZ: number
    csZ: number
    hsZ: number
    lakierZ: number
    lakier_miejscZ: number
    laminatZ: number
    pantoneZ: number
    cmykZ: number

    formatkowanie: number
    manualnieKosztCS: number
    manualnieKosztSito: number
    manualnieKosztFarb: number
    "polimery 114": number
    "polimery 17": number
    surowiec: any
    procent: any


    surowiecCena: number
    grupa_maszyn: string
    sito_puchn: number
    manualnie_koszt_sito: number
    unilever: number
    flexocmyk: number
    predkoscDruku: number
    use_min_koszt_rob: number
    zespoly:any

}


export class TreeCostParams implements ITreeCostParams {

    TYPY:any={}
   
    iml = 0
    isFolia = 0
    isPapier = 0
    exact = 1
    exactMetry = 0
    kolory = 0
    koloryZ = 0
    cs = 0
    hs = 0
    lakier = 0
    lakier_miejsc = 0
    laminat = 0
    bielCyfra = 0
    kolorCyfra = 0
    kolorInkjet = 0
    bielInkjet = 0
    silverCyfra = 0
    sitoProcent = 0
    sitoPuchnProcent = 0
    silverCyfraProcent = 0
    "sito" = 0
    "sito puchn" = 0
    sitoPuchn = 0
    sitoPuchnZ = 0
    pantone = 0
    cmyk = 0

    sitoZ = 0
    csZ = 0
    hsZ = 0
    lakierZ = 0
    lakier_miejscZ = 0
    laminatZ = 0
    pantoneZ = 0
    cmykZ = 0

    formatkowanie = 0
    manualnieKosztCS = 0
    manualnieKosztSito = 0
    manualnieKosztFarb = 0
    "polimery 114" = 0
    "polimery 17" = 0
    surowiec: any = { exact: 1, cena: 0, cena_podst: 0, leadTime: 0, surowiec: "", surowiecHandlowy: "" }
    procent: any = {} // surowiec, cmyk pantone cs distorun laminat sito sito puchn


    surowiecCena: number = 0
    grupa_maszyn: string = ""
    sito_puchn: number = 0;
    manualnie_koszt_sito: number = 0;
    unilever: number = 0;
    flexocmyk: number = 0;
    predkoscDruku: number = 0
    use_min_koszt_rob: number = 1
    zespoly:any={}


    constructor(tree: ITree) {
        this.TYPY['ETAP_FLEKSO_sito']                       ='sito'
        this.TYPY['ETAP_FLEKSO_sito puchn']                 ='sito puchnące'
        this.TYPY['ETAP_FLEKSO_cs']                         ='CS złocenie na zimno'
        
        this.TYPY['ETAP_FLEKSO_laminat']                    ='laminat'
        
        this.TYPY['ETAP_FLEKSO_lakier woda']               ='lakier woda'
        this.TYPY['ETAP_FLEKSO_lakier uv']                 ='lakier uv'
        this.TYPY['ETAP_FLEKSO_lakier uv lm']              ='lakier uv lm'
        this.TYPY['ETAP_FLEKSO_lakier led lm']             ='lakier led lm'

        this.TYPY['ETAP_FLEKSO_lakier woda miejscowy']     ='lakier woda miejscowy'
        this.TYPY['ETAP_FLEKSO_lakier uv miejscowy']       ='lakier uv miejscowy'
        this.TYPY['ETAP_FLEKSO_lakier uv lm miejscowy']    ='lakier uv lm miejscowy'
        this.TYPY['ETAP_FLEKSO_lakier led lm miejscowy']   ='lakier led lm miejscowy'

        this.TYPY['ETAP_FLEKSO_wolny']                  ='wolny'
        this.TYPY['ETAP_FLEKSO_primer']                  ='primer'


        this.TYPY['ETAP_FLEKSO_primer wodny']               ='primer wodny'
        this.TYPY['ETAP_FLEKSO_hs']                         ='HS złocenie na gorąco'
        this.TYPY['ETAP_FLEKSO_cs distorun']                ='CS złocenie na zimno'
        this.TYPY['ETAP_FLEKSO_cs distorun soczewka']       ='CS soczewka złocenie na zimno'
        this.TYPY['ETAP_FLEKSO_formatkowanie']              ='formatkowanie'
        this.TYPY['ETAP_FLEKSO_embossing rotacyjny']        ='tłoczenie'
        this.TYPY['ETAP_FLEKSO_metallic doming']            ='metallic doming'
        this.TYPY['ETAP_FLEKSO_tłoczenie offline']          ='tłoczenie'
        this.TYPY['ETAP_FLEKSO_pantone']                    ='pantone'
        this.TYPY['ETAP_FLEKSO_cmyk']                       ='cmyk'
        this.TYPY['ETAP_FLEKSO_peel-off']                   ='peel-off1'
        this.TYPY['ETAP_CYFRA_primer']                      ='primer'
        this.TYPY['ETAP_FLEKSO_poddruk rotacyjny']        ='tłoczenie'
        this.TYPY['ETAP_FLEKSO_embossing rotacyjny']        ='tłoczenie'
        this.TYPY['ETAP_FLEKSO_farba INKJET kolor MARK ANDY']           = 'inkjet kolor'
        this.TYPY['ETAP_FLEKSO_farba INKJET biała MARK ANDY']           = 'inkjet biały'

        this.TYPY['ETAP_CYFRA_kolor cyfra']                 ='kolor'
        this.TYPY['ETAP_CYFRA_biały cyfra']                 ='biały'
        this.TYPY['ETAP_CYFRA_silver cyfra']                ='srebrny'
        this.TYPY['ETAP_FINISHING_cs']                      ='CS złocenie na zimno'
        this.TYPY['ETAP_FINISHING_laminat']                 ='laminat'
        this.TYPY['ETAP_FINISHING_lakier woda']               ='lakier woda'
        this.TYPY['ETAP_FINISHING_lakier uv']                  ='lakier uv'
        this.TYPY['ETAP_FINISHING_lakier uv lm']                  ='lakier uv lm'
        this.TYPY['ETAP_FINISHING_lakier led lm']                  ='lakier led lm'

        this.TYPY['ETAP_FINISHING_lakier woda miejscowy']               ='lakier woda miejscowy'
        this.TYPY['ETAP_FINISHING_lakier uv miejscowy']                  ='lakier uv miejscowy'
        this.TYPY['ETAP_FINISHING_lakier uv lm miejscowy']                  ='lakier uv lm miejscowy'
        this.TYPY['ETAP_FINISHING_lakier led lm miejscowy']                  ='lakier led lm miejscowy'
        this.TYPY['ETAP_FINISHING_pantone']                 ='pantone'
        this.TYPY['ETAP_FINISHING_cmyk']                    ='cmyk'
        this.TYPY['ETAP_NEWFOIL_hs nf']                     ='HS złocenie na gorąco'
        this.TYPY['ETAP_NEWFOIL_hs tłoczenie nf']           ='HS złocenie na gorąco z tłoczeniem'
        this.TYPY['ETAP_NEWFOIL_tłoczenie nf']              ='tłoczenie'
        this.TYPY['ETAP_NEWFOIL_hs microembossing nf']      ='HS złocenie na gorąco microembossing'
        this.TYPY['ETAP_NEWFOIL_microembossing nf']         ='microembossing'
        
        this.handleCompatibility(tree)

        
    }


    handleCompatibility(calc: ITree) {

        console.log('handleCompatibility')
        for (let i = 0; i < calc.etapy.length; i++) {
            const etap = calc.etapy[i];
            if (etap) {

                if (etap.etap_typ == "ETAP_FLEKSO") {
                    if (!this.grupa_maszyn) {
                        this.grupa_maszyn = etap.grupa_maszyn;
                        this.predkoscDruku = etap.predkosc;
                    }
                }
                if (etap.etap_typ == "ETAP_CYFRA") {
                    if (!this.grupa_maszyn) {
                        this.grupa_maszyn = etap.grupa_maszyn;
                        this.predkoscDruku = etap.predkosc;
                    }
                }
                console.log('etap.etap_typ',etap.etap_typ)
                if (etap.etap_typ == "ETAP_SZTANCOWANIE_BEZ_DRUKU") {
                    if (!this.grupa_maszyn) {
                        this.grupa_maszyn = 'S';
                    }
                }

                if (!etap.technologie) etap.technologie = []

    
                this.iml = 0
                if (etap.etap_typ == "ETAP_SZTANCOWANIE_IML") this.iml = 1

                for (let j = 0; j < etap.technologie.length; j++) {
                    const technologia = etap.technologie[j];
                    
                    // dla IML nie było różnicy w cenie, testować dla surowców !iml
                    if (technologia.komponent_typ=="IML") this.iml = 1
                    console.log(">>>>>>>>>>> technologia", technologia.typ)
                    if (technologia.typ=="surowiec") {
                        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>surowiec")
                        console.dir(technologia)
                    }
                    console.log(">>>>>>>>>>> handleCompatibilityTechnologia start")
                    this.handleCompatibilityTechnologia(etap.etap_typ,technologia.typ, technologia.zmiana, technologia.procent, technologia.procent_pokrycia, technologia.krotnosc, this.zespoly, this)
                    console.log(">>>>>>>>>>> handleCompatibilitySurowiec start")

                    this.handleCompatibilitySurowiec(technologia);
                    console.log(">>>>>>>>>>> handleCompatibilitySurowiec end")

                }

            }
        }
        this.handleCompatibilityColors()
        return this;
    }


    handleCompatibilityColors() {
        const p=this;
        p.kolory = p.pantone+p.cmyk + p.cs + p.sito + p.sitoPuchn + p.lakier_miejsc; // LAMINATu zw. nie wliczamy
        p.koloryZ = p.pantoneZ + p.cmykZ + p.csZ + p.sitoZ + p.sitoPuchnZ + p.lakier_miejscZ; // LAMINATu zw. nie wliczamy
        p.flexocmyk = p.pantone + p.cmyk;
    }


    handleCompatibilitySurowiec(t: any) {

        const p=this;
        const typy: any = {}
        typy.BML = 2
        typy.CS = 1
        typy.FOLIA = 2
        typy.HS = 0
        typy.IML = 2
        typy.LAKIER = 0
        typy.LAMINAT = 0
        typy.METALLIC_DOMING = 0
        typy.PAPIER = 2
        typy.PLATYNKI = 2
        typy.SASZETKI = 2

     
       
        if (!t.komponent_typ) return;
        if (!typy[t.komponent_typ]) return;


        const s = p.surowiec
        s.nowy = 1
        s.isIML = 0;
        s.iml = 0
        if (t.komponent_id) { s.nowy = 0 }

        s.isFolia = 1; // papier bardziej restr.
        s.isPapier = 0; // papier bardziej restr.

        if (t.komponent_nazwa && typy[t.komponent_typ] == 2) {
            if (s.surowiec.length > 0) s.surowiec += ' ;'
            s.surowiec += t.komponent_nazwa;
        }

        if (t.komponent_typ == 'PAPIER') {
            s.isFolia = 0;
            s.isPapier = 1;
        }
        else if (t.komponent_typ == 'IML' || t.komponent_typ == 'BML' || t.komponent_typ == 'PLATYNKI') {
            s.isIML = 1;
            s.iml = 1
        }
        if (t.komponent_typ && t.komponent_typ == 'FOLIA') {
            s.isFolia = 1; // papier bardziej restr.
            s.isPapier = 0; // papier bardziej restr.
        }


        s.exact = 1;
        if (!t.komponent_exact) {
            s.exact = 0;
        }
        if (t.komponent_exact_metry) {

            if (!s.exactMetry || t.komponent_exact_metry < s.exactMetry) {
                s.exactMetry = t.komponent_exact_metry; // minimum z exact metry
            }
        }
   

        if (t.komponent_cena && t.typ=="surowiec") {
            s.cena += t.komponent_cena;
            s.cena = Math.round(s.cena * 100) / 100
            if (t.etap_typ == 'ETAP_START') {
                s.cena_podst += t.komponent_cena
                s.cena = Math.round(s.cena_podst * 100) / 100
            }
        }


        if (t.komponent_lead_time) {
            s.leadTime += t.komponent_lead_time;
        }

        s.surowiecHandlowy = s.surowiec;


        let text = ""
        if (s.nowy) text += "Nowy:"
        else text += "Std :"
        text += s.surowiec + ' ' + s.cena + ' EUR '
        if (s.exact) text += 'exact:tak'
        else {
            text += 'exact:nie'
            text += ' cięty z:' + s.exactMetry + 'mm '
        }
        if (s.isFolia) text += ' folia:tak'
        else text += ' folia: nie'
        if (s.isIML) text += ' IML:tak'
        else text += ' IML:nie'
        text += ' (' + s.leadTime + ' dni) '

        s.text = text;

    }






    handleCompatibilityTechnologia(etap:string,typ: string, zmiana: number, procent: number, procent_pokrycia: number, krotnosc: number, zespoly: any, p:any) {

        let key=etap+"_"+typ;
        key=key.trim()
        const tt:any=this.TYPY;
        
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleCompatibilityTechnologia", key)
        if ( tt[key] ) {
            const text=this.TYPY[key]

            //if (!p[key]) p[key]={ value:1, text:text } 
            //else p[key].value++;

            if (!zespoly[key]) zespoly[key]={ value:1, text:key } 
            else zespoly[key].value++;


        }
       
        if (typ == 'polimery 17') p['polimery 17']++;
        if (typ == 'polimery 114') p['polimery 114']++;


        if (typ == 'sito') p['sito']++;
        if (typ == 'sito puchn') p['sito puchn']++;
        if (typ == 'sito puchn') p.sitoPuchn++;

        if (typ == 'cs' || typ == 'metallic doming') p.cs++;
        if (typ.indexOf('distorun') > -1) p.cs++;

        if (typ.indexOf('miejscowy')>-1) p.lakier_miejsc++;
        else if (typ.indexOf('lakier')>-1) p.lakier++;
        
    
        if (typ == 'laminat') p.laminat++;
        if (typ == 'biały cyfra') p.bielCyfra++;
        if (typ == 'silver cyfra') p.silverCyfra++;
        if (typ == 'kolor cyfra') p.kolorCyfra++;
        if (typ == 'biały inkjet') p.bielInkjet++;
        if (typ == 'kolor inkjet') p.kolorInkjet++;
        if (typ == 'kolor cyfra') p.pantone++;
        // finishing
        if (typ == 'kolor uv finishing') p.pantone++;


        if (typ == 'pantone') {
            p.pantone++;
        }
        if (typ == 'cmyk') {
            p.cmyk++;
        }


        if (typ == 'sito' && zmiana) {
            p['sito zmiana']++
            p['sitoZ']++
        }
        if (typ == 'sito puchn' && zmiana) {
            p['sito puchn zmiana']++
            p['sitoPuchnZ']++
        }
        if ((typ == 'cs' || typ == 'metallic doming') && zmiana) {
            p.csZ++;
        }
        if (typ == 'lakier`' && zmiana) {
            p.lakierZ++;
        }
        if (typ == 'lakier miejsc' && zmiana) {
            p.lakier_miejscZ++;
        }
        if (typ == 'laminat' && zmiana) {
            p.laminatZ++;
        }
        if (typ == 'pantone' && zmiana) {
            p.pantoneZ++;
        }
        if (typ == 'cmyk' && zmiana) {
            p.cmykZ++;
        }
        if (typ && typ == 'formatkowanie') {
            p.formatkowanie++;
        }

        if (typ == 'kolor uv finishing' && zmiana) p.pantoneZ++;


        if (typ.indexOf('hs') > -1) {
            p.hs++;
            if (zmiana) p.hsZ++;
        }

        if (!p.procent) p.procent={}
        if (!p.procent[typ]) p.procent[typ]=0
        // dołożony 'surowiec'
        
        if (typ == 'surowiec' || typ == 'cs' || typ == 'metallic doming' || typ.indexOf('distorun')>-1 || typ == 'sito' || typ == 'sito puchn' || typ == 'pantone' || typ == 'cmyk' || typ == 'laminat' || (typ.indexOf('lakier')>-1)) {
            const proc = (procent / 100) * (procent_pokrycia / 100) / krotnosc;
            p.procent[typ] += proc;
        }

    }

   
}

